/* iter-51n — Shared formatting helpers.
 *
 * Pulled out of the ISBN dialogs (and a few other call-sites) to remove
 * verbatim duplication noted by the iter-51 code review (LOW finding).
 * Keep this module pure — no React, no I/O, no side effects.
 */

/** Hyphenate an ISBN-10 / ISBN-13 for display, or return as-is. */
export function formatIsbn(s) {
  if (!s) return '';
  const d = String(s).replace(/[^0-9Xx]/g, '');
  if (d.length === 13) return `${d.slice(0, 3)}-${d.slice(3, 4)}-${d.slice(4, 7)}-${d.slice(7, 12)}-${d.slice(12)}`;
  if (d.length === 10) return `${d.slice(0, 1)}-${d.slice(1, 4)}-${d.slice(4, 9)}-${d.slice(9)}`;
  return s;
}

/** Split a comma-separated string into a trimmed, non-empty array. */
export function splitCsv(text) {
  return String(text || '')
    .split(',')
    .map((s) => s.trim())
    .filter(Boolean);
}

/** Parse to an integer or null. Rejects NaN. */
export function intOrNull(v) {
  if (v === '' || v == null) return null;
  const n = parseInt(v, 10);
  return Number.isFinite(n) ? n : null;
}

/** Convert a dollars-formatted string ("17.99") to integer cents (1799),
 *  or null when the value is blank/non-numeric. */
export function dollarsToCents(v) {
  if (v === '' || v == null) return null;
  const n = parseFloat(v);
  return Number.isFinite(n) ? Math.round(n * 100) : null;
}

/** Render an ISO timestamp as a friendly "x minutes ago" string.
 *  Returns '' if iso is falsy or unparsable. */
export function timeAgo(iso, now = Date.now()) {
  if (!iso) return '';
  const t = Date.parse(iso);
  if (Number.isNaN(t)) return '';
  const diffSec = Math.max(0, Math.round((now - t) / 1000));
  if (diffSec < 5)        return 'just now';
  if (diffSec < 60)       return `${diffSec} seconds ago`;
  const m = Math.round(diffSec / 60);
  if (m < 60)             return `${m} minute${m === 1 ? '' : 's'} ago`;
  const h = Math.round(m / 60);
  if (h < 24)             return `${h} hour${h === 1 ? '' : 's'} ago`;
  const d = Math.round(h / 24);
  if (d < 30)             return `${d} day${d === 1 ? '' : 's'} ago`;
  const mo = Math.round(d / 30);
  if (mo < 12)            return `${mo} month${mo === 1 ? '' : 's'} ago`;
  const y = Math.round(mo / 12);
  return `${y} year${y === 1 ? '' : 's'} ago`;
}
